export const environment = {
  production: true,
  fcmApiKey:'BA0z76Dv0CY3cfVgb9311GhcegZ0AXUVH8SmW9pbJ6_P2xS5daeyQb-XN_qUc007bYK1YhIjYUaqQ9Jh5iDHVic',
};
